export default __webpack_public_path__ + "static/media/fail.7bed3bab.svg";